// construct the css locale from our internal locale
// so we can set the correct lang in the html tag
// in most cases the base language is enough to define the css locale
// but Chinese has two variants: simplified and traditional
// This allows different fallback fonts to be used for different languages
// e.g.
/*
:lang(ru), // Russian (Русский)
:lang(uk) {
  // Ukranian (Українська)
  font-family: 'Helvetica Now for TELUS', 'Geneva', 'Segoe UI', 'Calibri',
    'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
}

:lang(zh-Hant) {
  // Traditional Chinese (繁体中文)
  font-family: 'Helvetica Now for TELUS', 'PingFang TC', 'Microsoft Jhenghei',
    'Apple LiGothic', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
}

:lang(zh-Hans) {
  // Simplified Chinese (简体中文)
  font-family: 'Helvetica Now for TELUS', 'PingFang SC', 'Microsoft Yahei',
    'STHeiti', 'Simhei', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
}
*/
export const getCSSLocale = (locale: string): string => {
  const formattedLocale = locale.replace('_', '-').toLowerCase(); // css locales are case insensitive but consistency makes testing easier

  // ref https://workivate.atlassian.net/wiki/spaces/PK/pages/1407484004/Supported+Languages
  // for list of supported languages
  // note that the css locale is not the same as the internal locale for some languages
  switch (formattedLocale) {
    case 'zh-cn': // simplified Chinese
      return 'zh-Hans';
    case 'zh-hk': // traditional Chinese
      return 'zh-Hant';
    default:
      return formattedLocale.split('-')[0] || 'en'; // return the first part of the locale (e.g. 'en' from 'en_US')
  }
};
